export enum CustomerType {
  Individual,
  Ira,
  Joint,
}

export enum IraAccountType {
  TraditionalIra,
  RolloverIra,
  SepIra, // NOT SUPPORTED YET
  RothIra,
  SimpleIraParticipant,
}

export enum JointAccountType {
  JointRightsOfSurvivorship,
}

export enum EmploymentStatus {
  Employed,
  Retired,
  Student,
  Unemployed,
}

export enum TimeHorizon {
  Short,
  Average,
  Longest,
}

export enum LiquidityNeeds {
  VeryImportant,
  SomewhatImportant,
  NotImportant,
}

export enum ESigned {
  Yes,
  No,
}

export enum InvestmentExperience {
  None,
  Limited,
  Good,
  Extensive,
}

export enum InvestmentObjective {
  GrowthIncome,
  Growth,
  Income,
  CapitalPreservation,
  Speculation,
  MaximumGrowth,
  Balanced,
  Other,
}

export enum RiskTolerance {
  Low,
  Medium,
  High,
}

export enum Relationship {
  Spouse,
  Children,
  GrandChildren,
  Other,
}

export enum IsPoliticallyExposed {
  Yes,
  No,
}

export const STATES = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
  },
  {
    label: 'Federated States Of Micronesia',
    value: 'FM',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  {
    label: 'Employed',
    value: EmploymentStatus.Employed,
  },
  {
    label: 'Retired',
    value: EmploymentStatus.Retired,
  },
  {
    label: 'Student',
    value: EmploymentStatus.Student,
  },
  {
    label: 'Unemployed',
    value: EmploymentStatus.Unemployed,
  },
];

export const INCOME_OPTIONS = [
  {
    label: 'Between $0 and $25,000',
    value: { min: 0, max: 25000 },
  },
  {
    label: 'Between $25,001 and $50,000',
    value: { min: 25001, max: 50000 },
  },
  {
    label: 'Between $50,001 and $100,000',
    value: { min: 50001, max: 100000 },
  },
  {
    label: 'Between $100,001 and $200,000',
    value: { min: 100001, max: 200000 },
  },
  {
    label: 'Between $200,001 and $300,000',
    value: { min: 200001, max: 300000 },
  },
  {
    label: 'Between $300,001 and $500,000',
    value: { min: 300001, max: 500000 },
  },
  {
    label: 'Between $500,001 and $1,200,000',
    value: { min: 500001, max: 1200000 },
  },
  {
    label: 'Between $1,200,001 and $9,999,999',
    value: { min: 1200001, max: 9999999 },
  },
];

export const NET_WORTH_OPTIONS = [
  {
    label: 'Between $0 and $50,000',
    value: { min: 0, max: 50000 },
  },
  {
    label: 'Between $50,001 and $100,000',
    value: { min: 50001, max: 100000 },
  },
  {
    label: 'Between $100,001 and $200,000',
    value: { min: 100001, max: 200000 },
  },
  {
    label: 'Between $200,001 and $500,000',
    value: { min: 200001, max: 500000 },
  },
  {
    label: 'Between $500,001 and $1,000,000',
    value: { min: 500001, max: 1000000 },
  },
  {
    label: 'Between $1,000,001 and $5,000,000',
    value: { min: 1000001, max: 5000000 },
  },
  {
    label: 'Between $5,000,001 and $9,999,999',
    value: { min: 5000001, max: 9999999 },
  },
];

export const YES_NO_OPTIONS = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export const IS_POLITICALLY_EXPOSED_OPTIONS = [
  {
    label: 'Yes',
    value: IsPoliticallyExposed.Yes,
  },
  {
    label: 'No',
    value: IsPoliticallyExposed.No,
  },
];

export const LIQUIDITY_NEEDS_OPTIONS = [
  {
    label: 'Very Important',
    value: LiquidityNeeds.VeryImportant,
  },
  {
    label: 'Somewhat Important',
    value: LiquidityNeeds.SomewhatImportant,
  },
  {
    label: 'Not Important',
    value: LiquidityNeeds.NotImportant,
  },
];

export const TIME_HORIZON_OPTIONS = [
  {
    label: 'Less than a year',
    value: TimeHorizon.Short,
  },
  {
    label: '1-3 years',
    value: TimeHorizon.Average,
  },
  {
    label: 'More than 3 years',
    value: TimeHorizon.Longest,
  },
];

export const RISK_TOLERANCE_OPTIONS = [
  {
    label: 'Low',
    value: RiskTolerance.Low,
  },
  {
    label: 'Medium',
    value: RiskTolerance.Medium,
  },
  {
    label: 'High',
    value: RiskTolerance.High,
  },
];

export const INVESTMENT_EXPERIENCE_OPTIONS = [
  {
    label: 'None',
    value: InvestmentExperience.None,
  },
  {
    label: 'Limited',
    value: InvestmentExperience.Limited,
  },
  {
    label: 'Good',
    value: InvestmentExperience.Good,
  },
  {
    label: 'Extensive',
    value: InvestmentExperience.Extensive,
  },
];

export const INVESTMENT_OBJECTIVE_OPTIONS = [
  {
    label: 'Growth',
    value: InvestmentObjective.Growth,
  },
  {
    label: 'Income',
    value: InvestmentObjective.Income,
  },
  {
    label: 'Capital Preservation',
    value: InvestmentObjective.CapitalPreservation,
  },
  {
    label: 'Speculation',
    value: InvestmentObjective.Speculation,
  },
  {
    label: 'Other',
    value: InvestmentObjective.Other,
  },
];

export const E_SIGNED_OPTIONS = [
  {
    label: 'Yes',
    value: ESigned.Yes,
  },
  {
    label: 'No',
    value: ESigned.No,
  },
];

export const DOB_FE_FORMAT = 'MM-DD-YYYY';
export const DOB_BE_FORMAT = 'YYYY-MM-DD';

export const SSN_MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const DATE_MASK = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const PHONE_MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const MAX_407_LETTER_SIZE = 50; // MB

export const APEX_STATUS = ['Draft', 'Pending', 'Review', 'Error', 'Rejected'];

export const RELATIONSHIP_OPTIONS = [
  {
    label: 'Spouse',
    value: Relationship.Spouse,
  },
  {
    label: 'Children',
    value: Relationship.Children,
  },
  {
    label: 'Grand children',
    value: Relationship.GrandChildren,
  },
  {
    label: 'Other',
    value: Relationship.Other,
  },
];

export const INVESTMENT_TYPE_OPTS = [
  { value: 0, label: 'General investing' },
  { value: 1, label: 'Retirement investing' },
];

export const GENERAL_ACCOUNT_TYPE_OPTS = [
  { value: 0, label: 'Individual' },
  { value: 1, label: 'Joint' },
];

export const RETIREMENT_ACCOUNT_TYPE_OPTS = [
  { value: IraAccountType.TraditionalIra, label: 'Traditional IRA' },
  { value: IraAccountType.RolloverIra, label: 'Rollover IRA' },
  { value: IraAccountType.RothIra, label: 'Roth IRA' },
  { value: IraAccountType.SimpleIraParticipant, label: 'Simple IRA' },
];
